export const HOME = '/';
export const ACCOUNT = '/account';
export const DELETED = '/deleted';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const PASSWORD_RESET = '/password-reset';

/* Subroutes */

export const PROFILE = '/profile';
export const PASSWORD = '/password';
